/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { MenuItem, TextField, Tooltip } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CommentIcon from '../../../../../../assets/images/comment-dots.svg';
import CommentVisibleIcon from '../../../../../../assets/images/commen-visible-icon.svg';
import CommentAndCorrespondenceComponent from '../../../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { getExistingCorrLinkIds } from '../../../store/action';
import { checkActionAccessByRole } from '../../../../../../SharedModules/utilities/utilities';
import {
  setNDCSuccessMessage,
} from '../../../store/action';

export const NDCDetailsTextFieldComponent = ({
  disabled = true,
  value = '',
  maxLength = 40,
  label = '',
  onChange = () => {},
  className = '',
  select = false,
  selectData = [],
  selectReset = true,
  error = false,
  required = true,
  onBlur = () => {},
  helperText = '',
  ...rest
}) => {
  return (
    <div
      className={`mui-custom-form with-select w-100 ${className}`}
      id="label"
    >
      <TextField
        className="mandate-fields"
        label={label}
        tabIndex={0}
        fullWidth
        disabled={disabled}
        value={select ? (value ?? "") : value}
        placeholder=""
        inputProps={{ maxlength: maxLength, 'aria-labelledby': 'label' }}
        InputLabelProps={{
          shrink: true,
        }}
        aria-label="label"
        error={error}
        helperText={helperText}
        select={select}
        required={required}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
      >
        {select && selectReset && (
          <MenuItem key="" value="" className="frr-dropdown-blank-item" />
        )}
        {select &&
          selectData.length > 0 &&
          selectData.map((item, index) => {
            return (
              <MenuItem key={index} value={item.value}>
                {item.label ? `${item.label}` : `${item.value}`}
              </MenuItem>
            );
          })}
      </TextField>
    </div>
  );
};

export const ProviderIdDetailsTextFieldComponent = ({
  id = '',
  disabled = true,
  value = '',
  maxLength = 40,
  label = '',
  onChange = () => {},
  className = '',
  select = false,
  selectData = [],
  selectReset = true,
  error = false,
  required = false,
  ...rest
}) => {
  return (
    <div className={`mui-custom-form with-select w-100 ${className}`}>
      <TextField
        className="mandate-fields"
        tabIndex={0}
        id={id}
        label={label}
        fullWidth
        disabled={disabled}
        value={select ? (!value ? -1 : value) : value}
        placeholder=""
        inputProps={{ maxlength: maxLength, id }}
        InputLabelProps={{
          shrink: true,
        }}
        error={error}
        helperText=""
        select={select}
        required
        onChange={onChange}
        {...rest}
      >
        {select &&
          selectData.length > 0 &&
          selectData.map((item, index) => {
            return (
              <MenuItem
                key={item.codeValueID.codeValue}
                value={item.codeValueID.codeValue}
              >
                {`${item.codeValueID.codeValue} | ${item.shortDescription}`}

                {}
              </MenuItem>
            );
          })}
      </TextField>
    </div>
  );
};
export const getNDCValue = (obj) => {
  if (obj && obj.labelerCode && obj.productCode && obj.packageSize) {
    return `${obj.labelerCode}-${obj.productCode}-${obj.packageSize}`;
  }
  return '';
};

const NDCDetailsHeaderDetailsComponent = ({ currentNDCDetailsSelected }) => {
  const dispatch = useDispatch();
  const [commentShow, setCommentShow] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const commentsList = useSelector(
    (state) => state.sharedState.CommentsReducer.CommentListData
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
    }
  }, []);

  const handleExistingCommentList = async (data) => {
    setCorrLinkId(data?.corrLinkId);
    if (data) {
      const result = await getExistingCorrLinkIds({
        corrLinkId: [data.corrLinkId],
      });
      if (result && result.data?.length > 0) {
        result.data.forEach((elem) => {
          if (elem === data.corrLinkId) {
            setCommentShow(true);
          }
        });
      } else {
        setCommentShow(false);
      }
    }
  };
  useEffect(() => {
    if (currentNDCDetailsSelected) {
      handleExistingCommentList(currentNDCDetailsSelected);
    }
  }, [commentsList, currentNDCDetailsSelected]);

  return (
    <div className="mt-3 row">
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          label="NDC"
          value={getNDCValue(currentNDCDetailsSelected)}
          maxLength={13}
          required={false}

        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          label="Drug Name"
          value={
            currentNDCDetailsSelected && currentNDCDetailsSelected.drugName
          }
          maxLength={30}
          required={false}

        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          label="Earliest Claim Date"
          value={
            (currentNDCDetailsSelected &&
              currentNDCDetailsSelected.minClaimDt) ||
            ''
          }
          required={false}

        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          label="Labeler Name"
          value={
            currentNDCDetailsSelected && currentNDCDetailsSelected.labelerName
          }
          required={false}

        />
      </div>
      <div className="col-6">
        {hasAccess && (
          <div className="mui-custom-form w-100">
            Comments{' '}
            {currentNDCDetailsSelected && corrLinkId ? (
              <Tooltip title="Comment">
                <img
                  role="button"
                  onClick={() => {
                    dispatch(setNDCSuccessMessage(null));
                    setShowComments(true);
                  }}
                  tabIndex={'0'}
                  onKeyDown={(e) => {
                    // Handle Enter and Space key events
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault(); // Prevents the default space scrolling behavior
                      setShowComments(true);
                    }
                  }}
                  alt=" comment "
                  src={commentShow ? CommentVisibleIcon : CommentIcon}
                />
              </Tooltip>
            ) : (
              <img alt="comment" src={CommentIcon} />
            )}
          </div>
        )}
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="DRUG"
          corrLinkId={currentNDCDetailsSelected && corrLinkId}
          rowGridPrimaryKey={
            currentNDCDetailsSelected && currentNDCDetailsSelected.length > 0
              ? getNDCValue(currentNDCDetailsSelected)
              : 0
          }
        />
      ) : null}
    </div>
  );
};

export default NDCDetailsHeaderDetailsComponent;
